import './style.less';
import template from './template.html';

export default function() {
  'ngInject';

  return {
    scope: {
      video: '=',
      title: '=',
      msg: '='
    },
    template: template,
    restrict: 'E',
    controller: /* @ngInject */ $scope => {
      $scope.close = () => {
        document.getElementById('howDoI-container').style.display = 'none';
      };
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/howDoI/index.js